export default __webpack_public_path__ + "static/media/editedNotes.3dafc3e3.png";